import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { GroupedCaseStudy } from '@layouts/CaseStudies/types';

import * as styles from './KeyFeatures.module.scss';

export const KeyFeatures: React.FC<GroupedCaseStudy['keyFeatures']> = ({
	features,
	featuresImage,
}) => {
	const splittedFeatures = features ? features.split('\n') : [];
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<h2 className="font-size-small-title">Key Features</h2>
				<div
					className={classNames(
						styles.container,
						'mt-3 d-flex flex-column flex-lg-row'
					)}
				>
					<ul className={styles.features}>
						{splittedFeatures.map((feature, index) => (
							<li className="font-size-sm mt-2" key={index}>
								<span className="ml-1">{feature}</span>
							</li>
						))}
					</ul>
					{featuresImage && (
						<div className={styles.image}>
							<img src={featuresImage} alt="Key Feature image" />
						</div>
					)}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
